import React from 'react';
import { Container, Sprite, Text } from '@pixi/react';

function GambleAmount({ x, y, amountTextConfig, amountConfig, backgroundImage, spriteConfig }) {
  return (
    <Container x={x} y={y}>
      <Text
        {...amountTextConfig}
        anchor={0.5}
        resolution={2}
        style={{
          _fill: '#FFC33E',
          _fontSize: 20,
          _fontWeight: 500,
        }}
      />
      <Sprite texture={backgroundImage} {...spriteConfig} anchor={0.5} />
      <Text
        {...amountConfig}
        resolution={2}
        anchor={0.5}
        style={{ _fill: '#FFFFFF', _fontSize: 24, _fontWeight: 500 }}
      />
    </Container>
  );
}
export default GambleAmount;
